<template>
  <div class="mdc-layout-grid demo-grid section-privacy-security">
    <h3
      data-aos="fade"
      data-aos-duration="2000"
      id="feature2"
      class="feature mdc-typography--headline3 text-color mb-3"
    >
      {{ $t('title') }}
    </h3>
    <div class="mdc-layout-grid__inner">
      <div
        class="mdc-layout-grid__cell title-cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-1-phone"
      >
        <h6
          data-aos="zoom-out"
          data-aos-delay="500"
          data-aos-duration="500"
          class="mdc-typography--headline6 text-nav text-color text-center h-100 d-flex align-items-center justify-content-center donotsee swing"
        >
          🙈
        </h6>
      </div>
      <div
        class="mdc-layout-grid__cell title-cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-2-phone"
      >
        <h6
          data-aos="zoom-in"
          data-aos-delay="650"
          data-aos-duration="500"
          class="mdc-typography--headline6 text-nav text-color text-center h-100 d-flex align-items-center justify-content-center donothear bounceInUp"
        >
          🙉
        </h6>
      </div>
      <div
        class="mdc-layout-grid__cell title-cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-1-phone"
      >
        <h6
          data-aos="zoom-out"
          data-aos-delay="750"
          data-aos-duration="500"
          class="mdc-typography--headline6 text-nav text-color text-center h-100 d-flex align-items-center justify-content-center donottalk bounceInDown"
        >
          🙊
        </h6>
      </div>

      <!-- ROW 1-->
      <div
        class="mdc-layout-grid__cell grid-cell mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone position-relative"
      >
        <div class="Guides__container position-absolute">
          <div class="Guides__guide"></div>
          <div class="Guides__guide"></div>
          <div class="Guides__guide"></div>
          <div class="Guides__guide"></div>
          <div class="Guides__guide"></div>
          <div class="Guides__guide"></div>
          <div class="Guides__guide"></div>
          <div class="Guides__guide"></div>
        </div>
        <!-- CARD CONTENT -->
        <div class="card-content pane-content p-5">
          <h6 class="mdc-typography--headline6 feature2-text-color">
            {{ $t('card1.title') }}
          </h6>
          <p class="mdc-typography--headline5 text-color font-weight-bold">
            {{ $t('card1.subtitle') }}
          </p>
          <figure class="image-feature2-item1" role="img-center"></figure>
          <!-- <picture class="img-center">
            <source
              srcset="/img/privacy/signin-with-google.png"
              media="(prefers-color-scheme: dark)"
              loading="lazy"
            />
            <source
              srcset="/img/privacy/signin-with-google.png"
              media="(prefers-color-scheme: light), (prefers-color-scheme: no-preference)"
              loading="lazy"
            />
            <img
              src="/img/privacy/signin-with-google.png"
              id="screenshot"
              loading="lazy"
              class="img-fluid"
            />
          </picture> -->
        </div>
        <!-- END CARD CONTENT -->
      </div>
      <!-- END ROW 1 -->
      <!-- ROW 2-->
      <div
        class="mdc-layout-grid__cell grid-cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
      >
        <!-- CARD CONTENT -->
        <div class="card-content pane-content p-5">
          <h6 class="mdc-typography--headline6 feature2-text-color">
            {{ $t('card2.title') }}
          </h6>
          <p class="mdc-typography--headline5 text-color font-weight-bold">
            {{ $t('card2.subtitle') }}
          </p>
          <picture class="img-center position-relative h-100">
            <source
              srcset="/img/privacy/2fa.png"
              media="(prefers-color-scheme: dark)"
              loading="lazy"
            />
            <source
              srcset="/img/privacy/2fa.png"
              media="(prefers-color-scheme: light), (prefers-color-scheme: no-preference)"
              loading="lazy"
            />
            <img src="/img/privacy/2fa.png" id="screenshot" loading="lazy" />
          </picture>
          <picture class="img-center" id="img-phone">
            <source
              srcset="/img/privacy/2fa-iphone.png"
              media="(prefers-color-scheme: dark)"
              loading="lazy"
            />
            <source
              srcset="/img/privacy/2fa-iphone.png"
              media="(prefers-color-scheme: light), (prefers-color-scheme: no-preference)"
              loading="lazy"
            />
            <img
              src="/img/privacy/2fa-iphone.png"
              id="phone"
              loading="lazy"
              data-aos="slide-up"
              data-aos-duration="800"
              data-aos-delay="3000"
              data-aos-anchor=".feature2-text-color"
            />
          </picture>
        </div>
        <!-- END CARD CONTENT -->
      </div>
      <div
        class="mdc-layout-grid__cell grid-cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
      >
        <!-- CARD CONTENT -->
        <div class="card-content pane-content p-5 map-session-bg z-1">
          <h6 class="mdc-typography--headline6 feature2-text-color">
            {{ $t('card3.title') }}
          </h6>
          <p
            class="mdc-typography--headline5 text-color font-weight-bold always-white"
          >
            {{ $t('card3.subtitle') }}
          </p>
          <figure
            class="image-feature2-item3"
            style="z-index:2;"
            role="img-map"
          ></figure>
          <video
            class="layer position-absolute"
            preload="auto"
            loop=""
            muted=""
            autoplay=""
            playsinline=""
            style="left:-50%;right:0;top:0;z-index:-1;"
          >
            <source src="/video/sessions-view.mp4" type="video/mp4" />
          </video>

          <div class="mdc-data-table mt-auto w-100" style="z-index:3;">
            <table class="mdc-data-table__table" aria-label="Sesiuni">
              <thead>
                <tr class="mdc-data-table__header-row">
                  <th
                    class="mdc-data-table__header-cell"
                    role="columnheader"
                    scope="col"
                  >
                    Locație aproximativă
                  </th>
                  <th
                    class="mdc-data-table__header-cell mdc-data-table__header-cell--numeric"
                    role="columnheader"
                    scope="col"
                  >
                    Sistem de operare
                  </th>
                  <th
                    class="mdc-data-table__header-cell mdc-data-table__header-cell--numeric"
                    role="columnheader"
                    scope="col"
                  >
                    Data
                  </th>
                  <th
                    class="mdc-data-table__header-cell"
                    role="columnheader"
                    scope="col"
                  >
                    Status
                  </th>
                </tr>
              </thead>
              <tbody class="mdc-data-table__content">
                <tr class="mdc-data-table__row">
                  <td class="mdc-data-table__cell">Medgidia, RO</td>
                  <td
                    class="mdc-data-table__cell mdc-data-table__cell--numeric"
                  >
                    Windows 10
                  </td>
                  <td
                    class="mdc-data-table__cell mdc-data-table__cell--numeric"
                  >
                    Acum un minut
                  </td>
                  <td class="mdc-data-table__cell">Succes</td>
                </tr>
                <tr class="mdc-data-table__row">
                  <td class="mdc-data-table__cell">Constanța, RO</td>
                  <td
                    class="mdc-data-table__cell mdc-data-table__cell--numeric"
                  >
                    Android 11
                  </td>
                  <td
                    class="mdc-data-table__cell mdc-data-table__cell--numeric"
                  >
                    22.03.2020
                  </td>
                  <td class="mdc-data-table__cell">Succes</td>
                </tr>
                <tr class="mdc-data-table__row">
                  <td class="mdc-data-table__cell">Tulum, MX</td>
                  <td
                    class="mdc-data-table__cell mdc-data-table__cell--numeric"
                  >
                    iOS 13
                  </td>
                  <td
                    class="mdc-data-table__cell mdc-data-table__cell--numeric"
                  >
                    25.07.2019
                  </td>
                  <td class="mdc-data-table__cell">Succes</td>
                </tr>
                <tr class="mdc-data-table__row">
                  <td class="mdc-data-table__cell">Medellín, CO</td>
                  <td
                    class="mdc-data-table__cell mdc-data-table__cell--numeric"
                  >
                    iOS 13
                  </td>
                  <td
                    class="mdc-data-table__cell mdc-data-table__cell--numeric"
                  >
                    18.06.2019
                  </td>
                  <td class="mdc-data-table__cell">Succes</td>
                </tr>
                <tr class="mdc-data-table__row">
                  <td class="mdc-data-table__cell">Miami, Florida SUA</td>
                  <td
                    class="mdc-data-table__cell mdc-data-table__cell--numeric"
                  >
                    iOS 13
                  </td>
                  <td
                    class="mdc-data-table__cell mdc-data-table__cell--numeric"
                  >
                    5.05.2019
                  </td>
                  <td class="mdc-data-table__cell">Succes</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- END CARD CONTENT -->
      </div>
      <!-- END ROW 2 -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacySecurity'
}
</script>

<i18n>
{
  "en": {
    "title": "Privacy and Security",
    "card1": {
      "title": "Sign in with Google",
      "subtitle": "A simple way to connect"
    },
    "card2": {
      "title": "Two-Factor Authentication",
      "subtitle": "Al doilea pas de după introducerea parolei se asigură că dvs. sunteți persoana care se conectează."
    },
    "card3": {
      "title": "Sessions",
      "subtitle": "Vedeți când și unde v-ați folosit contul."
    }
  },
  "ro": {
    "title": "Confidențialitate și securitate",
    "card1": {
      "title": "Conectează-te cu Google",
      "subtitle": "O modalitate simplă de a vă conecta."
    },
    "card2": {
      "title": "Al doilea pas de autentificare",
      "subtitle": "Al doilea pas de după introducerea parolei se asigură că dvs. sunteți persoana care se conectează."
    },
    "card3": {
      "title": "Sesiuni de autentificare",
      "subtitle": "Vedeți când și unde v-ați folosit contul."
    }
  },
  "de": {
    "title": "Privacy and Security",
    "card1": {
      "title": "Sign in with Google",
      "subtitle": "A simple way to connect"
    },
    "card2": {
      "title": "Two-Factor Authentication",
      "subtitle": "Al doilea pas de după introducerea parolei se asigură că dvs. sunteți persoana care se conectează."
    },
    "card3": {
      "title": "Sessions",
      "subtitle": "Vedeți când și unde v-ați folosit contul."
    }
  }
}
</i18n>
<style>
.z-1 {
  z-index: 1;
}
.img-center {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  justify-content: center;
}
.img-right {
  display: flex;
  justify-content: flex-end;
}
#screenshot {
}
#phone {
  max-width: 200px;
  position: absolute;
  bottom: -200px;
}
/* #img-phone {
  max-width: 200px;
} */
@media (prefers-color-scheme: dark) {
  .image-feature2-item1 {
    width: 100%;
    height: 100%;
    left: 0;
    background-size: 340px 591px;
    background-repeat: no-repeat;
    background-image: url(/img/privacy/signin-with-google.png);
    bottom: 60px;
  }
  .mdc-data-table {
    -webkit-backdrop-filter: saturate(180%) blur(20px);
    backdrop-filter: saturate(180%) blur(20px);
    background-color: var(--navbar-bg) !important;
    border-bottom: 1px solid var(--navbar-border-bottom);
    -webkit-transition: background-color 0.5s cubic-bezier(0.28, 0.11, 0.32, 1);
    transition: background-color 0.5s cubic-bezier(0.28, 0.11, 0.32, 1);
    border-radius: 4px;
    border-width: 1px;
    border-style: solid;
    border-color: rgb(51, 51, 51);
    -webkit-overflow-scrolling: touch;
    display: inline-flex;
    flex-direction: column;
    box-sizing: border-box;
    overflow-x: auto;
  }
  .mdc-data-table__header-cell {
    color: var(--text-color);
    -webkit-backdrop-filter: saturate(180%) blur(20px);
    backdrop-filter: saturate(180%) blur(20px);
    background-color: var(--navbar-bg) !important;
    border-bottom: 1px solid var(--navbar-border-bottom);
    -webkit-transition: background-color 0.5s cubic-bezier(0.28, 0.11, 0.32, 1);
    transition: background-color 0.5s cubic-bezier(0.28, 0.11, 0.32, 1);
  }
  .mdc-data-table__cell {
    color: var(--text-color);
  }
  .map-session-bg {
    background-image: url(/img/privacy/earth.png);
    /* background-image: url(https://www.nasa.gov/sites/default/files/styles/full_width_feature/public/thumbnails/image/westernhemisphere_geos_2019246_lrg.jpg) !important; */
    background-repeat: no-repeat;
    /* background-position: bottom; */
    background-size: unset;
  }
}
@media (prefers-color-scheme: light) {
  .image-feature2-item1 {
    width: 100%;
    height: 100%;
    left: 0;
    background-size: 340px 591px;
    background-repeat: no-repeat;
    background-image: url(/img/privacy/signin-with-google2.png);
    bottom: 60px;
  }
}
</style>
